import React, { FC } from "react";
import { format } from "date-fns";
import classNames from "classnames";

import { useInsuranceLabels } from "../../../Utils/Context/labelsContext";

import { Placeholder } from "../../../Partials/Placeholder";
import { StreamLineIcon } from "../../../../SvgIcon/StreamLineIcon";
import { DoctorBarStatus } from "../Types/types";

interface DoctorBarAppointmentProps {
  date?: Date;
  barState: DoctorBarStatus;
}

export const DoctorBarAppointment: FC<DoctorBarAppointmentProps> = (props) => {
  const { date, barState } = props;

  const { labels } = useInsuranceLabels();

  return (
    <div className="doctorBar__date">
      <Placeholder loadingDone={barState !== "loading"}>
        {barState === "noFilters" && (
          <span className="doctorBar__placeholderText">
            {labels.chooseTreatmentAndServiceLabel}
          </span>
        )}
      </Placeholder>
      {barState === "withFilters" && (
        <div
          className={classNames(
            "doctorBar__appointment",
            "doctorBar__appointment--extendedWidth"
          )}
        >
          <div className="doctorBar__appointmentDate">
            <span className="doctorBar__appointmentDateLabel">
              {date ? (
                <>
                  {format(date, "dd/MM/yyyy")}
                  <br />
                  {format(date, "HH:mm")}
                </>
              ) : (
                labels.dateUnavailableLabel
              )}
              <span className="doctorBar__appointmentDateIcon">
                <StreamLineIcon
                  iconName="s-calendar"
                  className="doctorBar__appointmentIcon"
                />
              </span>
            </span>
          </div>
        </div>
      )}
    </div>
  );
};
